import { __exportAll as e } from "../../_virtual/_rolldown/runtime.mjs";
import { cn as t } from "../../lib/utils.mjs";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { Tooltip as i } from "@base-ui/react/tooltip";
//#region src/components/ui/tooltip.tsx
var a = /* @__PURE__ */ e({
	Tooltip: () => s,
	TooltipContent: () => l,
	TooltipProvider: () => o,
	TooltipTrigger: () => c
});
function o({ delay: e = 0, ...t }) {
	return /* @__PURE__ */ n(i.Provider, {
		"data-slot": "tooltip-provider",
		delay: e,
		...t
	});
}
function s({ ...e }) {
	return /* @__PURE__ */ n(i.Root, {
		"data-slot": "tooltip",
		...e
	});
}
function c({ nativeButton: e, ...t }) {
	return /* @__PURE__ */ n(i.Trigger, {
		"data-slot": "tooltip-trigger",
		...t
	});
}
function l({ className: e, side: a = "top", sideOffset: o = 4, align: s = "center", alignOffset: c = 0, children: l, ...u }) {
	return /* @__PURE__ */ n(i.Portal, { children: /* @__PURE__ */ n(i.Positioner, {
		align: s,
		alignOffset: c,
		side: a,
		sideOffset: o,
		className: "isolate z-500",
		children: /* @__PURE__ */ r(i.Popup, {
			"data-slot": "tooltip-content",
			className: t("data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 rounded-none px-3 py-1.5 text-xs data-[side=inline-start]:slide-in-from-end-2 data-[side=inline-end]:slide-in-from-start-2 bg-foreground text-background z-500 w-fit max-w-xs origin-(--transform-origin)", e),
			...u,
			children: [l, /* @__PURE__ */ n(i.Arrow, { className: "size-2.5 translate-y-[calc(-50%-2px)] rotate-45 rounded-none data-[side=inline-end]:top-1/2! data-[side=inline-end]:-start-1 data-[side=inline-end]:-translate-y-1/2 data-[side=inline-start]:top-1/2! data-[side=inline-start]:-end-1 data-[side=inline-start]:-translate-y-1/2 bg-foreground fill-foreground z-500 data-[side=bottom]:top-1 data-[side=left]:top-1/2! data-[side=left]:-right-1 data-[side=left]:-translate-y-1/2 data-[side=right]:top-1/2! data-[side=right]:-left-1 data-[side=right]:-translate-y-1/2 data-[side=top]:-bottom-2.5" })]
		})
	}) });
}
//#endregion
export { s as Tooltip, l as TooltipContent, o as TooltipProvider, c as TooltipTrigger, a as tooltip_exports };
